class RentalExtension {
  constructor() {
    const urlParams = new URLSearchParams(window.location.search);
    this.extensionOrderId = urlParams.get('order_id');  // This will be 153
    this.originalOrderId = urlParams.get('original_order_id'); // This should be 150
    this.email = urlParams.get('email');
    this.selectedPeriod = null;

    // console.log('Extension Order ID:', this.extensionOrderId);
    // console.log('Original Order ID:', this.originalOrderId);

    if (!this.extensionOrderId || !this.originalOrderId || !this.email) {
      console.error('Missing required parameters');
      this.showError('Invalid URL parameters');
      return;
    }

    this.init();
  }

  async init() {
    try {
      // Use extensionOrderId for API calls since backend expects that
      // console.log(`Fetching extension options for order ${this.extensionOrderId}`);
      
      const response = await fetch(
        `https://wonderent.wonderchef.com/api/rentals/customer/public/extension-options/${encodeURIComponent(this.email)}/${this.extensionOrderId}/`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      const data = await response.json();
      
      if (!response.ok) {
        console.error('Extension options error:', data);
        throw new Error(data.error || 'Failed to load extension options');
      }

      this.options = data;
      this.render();
    } catch (error) {
      console.error('Error initializing extension:', error);
      this.showError(error.message);
    }
  }

  showError(message) {
    console.error(message);
    alert(message);
  }

  async handleExtend() {
    if (!this.selectedPeriod) return;

    try {
      // Use extensionOrderId for the API call
      const response = await fetch(
        `https://wonderent.wonderchef.com/api/rentals/customer/public/extend/${encodeURIComponent(this.extensionOrderId)}/?email=${encodeURIComponent(this.email)}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            period: this.selectedPeriod
          })
        }
      );

      const data = await response.json();
      // console.log('Extension response:', data);

      if (!response.ok) {
        throw new Error(data.error + (data.details ? `\n${data.details}` : ''));
      }

      // console.log('Extension initiated:', data);
      
      const options = {
        key: this.razorpayKey,
        amount: data.amount,
        currency: data.currency,
        name: 'WonderRent',
        description: `Rental Extension - ${this.selectedPeriod}`,
        order_id: data.razorpay_order_id,
        handler: async (response) => {
          try {
              console.log('Payment successful, verifying...', {
                  payment_id: response.razorpay_payment_id,
                  order_id: data.razorpay_order_id
              });
              
              const verifyResponse = await fetch(
                  'https://wonderent.wonderchef.com/api/rentals/customer/public/complete-extension/',
                  {
                      method: 'POST',
                      headers: {
                          'Content-Type': 'application/json'
                      },
                      body: JSON.stringify({
                          razorpay_payment_id: response.razorpay_payment_id,
                          razorpay_signature: response.razorpay_signature,
                          razorpay_order_id: data.razorpay_order_id,
                          original_order_id: this.originalOrderId // Include this in verification
                      })
                  }
              );

              const verifyData = await verifyResponse.json();
              
              if (verifyResponse.ok) {
                  // Redirect to original order page using originalOrderId
                  window.location.href = `/pages/rental-order?order_id=${this.originalOrderId}&email=${encodeURIComponent(this.email)}`;
              } else {
                  throw new Error(verifyData.error || 'Failed to complete extension payment');
              }

          } catch (error) {
         //     console.error('Error completing extension:', error);
              this.showError(error.message || 'Failed to complete extension payment');
          }
        },
        modal: {
          ondismiss: () => {
            // console.log('Payment modal closed');
          },
          escape: true
        },
        prefill: {
          email: this.email
        },
        theme: {
          color: '#3399cc'
        }
      };
      
      const rzp = new Razorpay(options);
      rzp.open();
    } catch (error) {
    //  console.error('Error initiating extension:', error);
      this.showError(error.message);
    }
  }

  render() {
    const root = document.getElementById('rental-extension-root');
    if (!root) {
  //    console.error('Root element not found');
      return;
    }

    const selectedOption = this.getSelectedOption();
    
    root.innerHTML = `
      <div class="extension-container">
        <h2>Extend Tenure</h2>
        <p>Enjoy greater savings by choosing longer rental periods</p>
        
        <div class="period-options">
          ${this.options.map(option => `
            <div class="period-option ${this.selectedPeriod === option.period ? 'selected' : ''}" 
                 data-period="${option.period}">
              <div class="period-details">
                <span class="months">${option.months} Month${option.months > 1 ? 's' : ''}</span>
                <div class="price">
                  <span class="amount">₹${option.monthly_amount}</span>
                  <span class="per-month">per month</span>
                </div>
              </div>
            </div>
          `).join('')}
        </div>

        ${selectedOption ? `
          <div class="total-row">
            <span>Total Rent:</span>
            <span class="total-amount">₹${selectedOption.total_amount}</span>
          </div>
          <button class="extend-button">Complete Payment</button>
        ` : ''}
        
        <p>Monthly rental rate will not go lower than the rate in the 12-month rental bracket</p>
      </div>
    `;

    // Attach event listeners after rendering
    this.attachEventListeners();
  }

  attachEventListeners() {
    const periodOptions = document.querySelectorAll('.period-option');
    const extendButton = document.querySelector('.extend-button');

    // Remove existing event listeners
    periodOptions.forEach(option => {
      option.replaceWith(option.cloneNode(true));
    });
    if (extendButton) {
      extendButton.replaceWith(extendButton.cloneNode(true));
    }

    // Add new event listeners
    document.querySelectorAll('.period-option').forEach(option => {
      option.addEventListener('click', () => {
        // console.log('Period option clicked:', option.dataset.period);
        this.selectedPeriod = option.dataset.period;
        this.render();
      });
    });

    const newExtendButton = document.querySelector('.extend-button');
    if (newExtendButton) {
      newExtendButton.addEventListener('click', () => {
        // console.log('Extend button clicked');
        this.handleExtend();
      });
    }
  }

  getSelectedOption() {
    return this.options?.find(option => option.period === this.selectedPeriod);
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new RentalExtension();
});